// extracted by mini-css-extract-plugin
module.exports = {"images":"ReviewImages_images__Lnz2g","image":"ReviewImages_image__CysVq","overlay":"ReviewImages_overlay__jCgOF"};